export default __webpack_public_path__ + "static/media/ion_restaurant.a610ff9d.svg";